declare var $: any;

import { LandComponent } from "../components/landComponent";
import { TextBox } from "../components/textBox";

export class Land {
    static init() {
        Land.reload();
        $(".js-autosave-replace").on("reloaded", Land.reload);
    }

    static reload() {
        LandComponent.init();
        Land.disablePurchasePrice();

        $("input[type=radio][name='Availability']", ".js-land").change(Land.disablePurchasePrice);
    }

    static disablePurchasePrice() {
        const $textBox = $(".js-land input[name='PurchasePrice']");

        $(".js-land input[type=radio][name='Availability']").each(function () {
            const $el = $(this);

            if ($el.val() === "Rented") {
                const isChecked: boolean = $el.is(":checked");

                $textBox.prop("disabled", isChecked);
                if (isChecked) {
                    const textBox = new TextBox($textBox);
                    textBox.hideValidationError();
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/land.ts